// extracted by mini-css-extract-plugin
export default {"customsMessagingWrapper":"_7e723f07","customsMessagingMessage":"_71a47cdf"};